import api, { ApiResponse } from './api';

export interface TeamActivityRow {
  user_id: string;
  name: string;
  email: string;
  role: string;
  active_minutes: number;
  days_active: number;
  sessions: number;
  baseline_minutes: number;
  by_area: Record<string, number>;
  by_device: Record<string, number>;
  reads: number;
  writes: number;
  mcp_reads: number;
  mcp_writes: number;
  last_active: string | null;
  last_seen: string | null;
  /** Active minutes by weekday (Mon..Sun) × hour, row-major. */
  heatmap: number[];
}

export interface ActivityMinute { t: string; area: string; device: string; page: string }
export interface ActivityEvent {
  t: string; channel: 'ui' | 'mcp'; kind: 'read' | 'write'; area: string;
  entity_type: string; tool: string; mcp_client: string; page: string;
}
export interface ActivityChange { created_at: string; action: string; entity_type: string | null; entity_id: string | null; entity_name: string | null }

export interface UserActivityDetail {
  user: { id: string; name: string; email: string; role: string };
  minutes: ActivityMinute[];
  events: ActivityEvent[];
  changes: ActivityChange[];
  events_truncated: boolean;
}

export interface TeamActivityWindow {
  date_from: string;
  date_to: string;
}

export const teamActivityService = {
  summary: async (w: TeamActivityWindow): Promise<TeamActivityRow[]> =>
    (await api.post<ApiResponse<{ rows: TeamActivityRow[] }>>('/team-activity', w)).data.data!.rows,
  detail: async (userId: string, w: TeamActivityWindow): Promise<UserActivityDetail> =>
    (await api.post<ApiResponse<UserActivityDetail>>(`/team-activity/${userId}`, w)).data.data!,
  heartbeat: async (page: string): Promise<void> => {
    await api.post('/activity/heartbeat', { page });
  },
};
